import "./index.scss";
import { GRAPHQL_CMS_BASE_URL } from "constants/endpoints";
import { withApolloProvider } from "providers/ApolloClientProvider";
import { useGetActions } from "./utils/useGetActions";
import { ActionCard } from "components/UI/molecules";

const HomeActionCards = () => {
  const { loading, data, error } = useGetActions();

  const isReady = !loading && !error && data;

  if (isReady)
    return (
      <div className="home-action-cards">
        {data.list.map((card, index) => {
          const desktopClassNames = [
            "vertical",
            "horizontal",
            "horizontal rtl",
            "vertical"
          ];

          return (
            <ActionCard
              key={card.cta}
              imageDesktop={card.imageDesktop}
              imageMobile={card.imageMobile}
              title={card.title}
              description={card.description}
              cta={card.cta}
              linkTo={card.linkTo}
              customClassName={desktopClassNames[index]}
            />
          );
        })}
      </div>
    );
};

export default withApolloProvider(HomeActionCards, {
  graphqlEndpoint: GRAPHQL_CMS_BASE_URL
});
